<template>
  <wsp-modal>
    <v-card flat class="pb-3">
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            {{ $t('tenant.contact.form.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-layout row wrap>
          <v-flex xs12>
            <advice color="primary" class="d-inline-block">
              {{ $t('tenant.contact.form.tip') }}
            </advice>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-form
        ref="form"
        v-model="valid"
        v-on:submit.prevent="
          () => {
            return false;
          }
        "
      >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="px-2">
              <v-select
                v-model="contact.type"
                :items="items"
                item-text="text"
                item-value="value"
                return-object
                :rules="mandatoryRules"
                :label="$t('tenant.contact.form.type.label')"
                required
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 class="px-2">
              <v-text-field
                :label="$t('tenant.contact.form.address.label')"
                v-model="contact.address"
                name="address"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 class="px-2">
              <v-text-field
                :label="$t('tenant.contact.form.observations.label')"
                v-model="contact.observation"
                name="observation"
                type="text"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-layout>
            <v-flex text-xs-right xs12>
              <v-btn
                round
                flat
                color="primary"
                class="capitalize"
                @click="visible = !visible"
              >
                {{ $t('global.button.cancel') }}
              </v-btn>

              <v-btn
                round
                flat
                color="primary"
                class="capitalize"
                @click="resetForm"
              >
                {{ $t('global.button.clear') }}
              </v-btn>

              <v-btn
                :disabled="!valid"
                type="submit"
                outline
                color="accent"
                class="capitalize white--text"
                @click="submit"
                round
              >
                {{ $t('tenant.contact.form.button') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import Advice from '@/components/commons/Advice';
import tenantService from '@/services/tenantService';
import manageErrorService from '@/services/manageErrorService';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'GarageContactForm',
  components: {
    [Advice.name]: Advice,
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {
    mandatoryRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v =>
          (!!v && (typeof v !== 'string' || v.trim().length !== 0)) ||
          this.$i18n.t('global.validation.required.text')
      ];
    }
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      valid: false,
      items: [
        {
          id: 0,
          text: this.$i18n.t('tenant.contact.form.type.PERSONAL'),
          value: 'PERSONAL'
        },
        {
          id: 1,
          text: this.$i18n.t('tenant.contact.form.type.BUSINESS'),
          value: 'BUSINESS'
        }
      ],
      contact: {
        type: '',
        address: '',
        observation: ''
      }
    };
  },
  created() {
    this.resetForm();
  },
  methods: {
    resetForm() {
      this.contact.type = '';
      this.contact.address = '';
      this.contact.observation = '';
    },

    async submit() {
      this.isLoading = true;

      let payload = this.contact;

      if (this.contact.type !== null) {
        payload.type = this.contact.type.value;
      }

      let results = await tenantService.contact(payload);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        this.valid = true;
        return;
      }

      this.visible = false;

      this.$emit('on-success', {});

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('teletag.letter.toast.success'),
        type: 'info',
        doNotTranslate: true
      });

      this.$mam.eventRegisterStep4();

      this.isLoading = false;
    }
  }
};
</script>
